<template>
  <div class="info-container">
    <div class="info-box">
      <h2>修改手机号</h2>
      
      <el-form :model="userInfo" :rules="rules" ref="infoForm" label-width="100px">
        
        <!-- 手机号 -->
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="userInfo.mobile" placeholder="请输入手机号">
            <template slot="append">
              <el-button @click="sendCode" :disabled="codeTimer > 0">
                {{ codeTimer > 0 ? `${codeTimer}s` : '获取验证码' }}
              </el-button>
            </template>
          </el-input>
        </el-form-item>

        <!-- 验证码 -->
        <el-form-item label="验证码" prop="code">
          <el-input v-model="userInfo.code" placeholder="请输入验证码"></el-input>
        </el-form-item>

        <!-- 提交按钮 -->
        <el-form-item>
          <el-button type="primary" @click="submitForm" :loading="loading">确认修改</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { updateMobile, sendSms } from '@/api/signUp';

export default {
  name: 'Phone',
  data() {
    // 手机号验证
    const validatePhone = (rule, value, callback) => {
      const phoneReg = /^1[3-9]\d{9}$/;
      if (!value) {
        callback(new Error('请输入手机号'));
      } else if (!phoneReg.test(value)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    };

    return {
      userInfo: {
        mobile: '',
        code: ''
      },
      rules: {
        mobile: [
          { validator: validatePhone, trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      loading: false,
      codeTimer: 0,
      timer: null
    };
  },
  mounted() {
    // 可选：如果需要在页面加载时回填当前登录用户的手机号
    this.loadUserInfo();
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    // 加载用户信息
    loadUserInfo() {
      const userInfoStr = localStorage.getItem('userInfo');
      if (userInfoStr) {
        const userInfo = JSON.parse(userInfoStr);
        this.userInfo.mobile = userInfo.mobile || '';
      }
    },

    // 发送验证码
    sendCode() {
      if (!this.userInfo.mobile) {
        this.$message.warning('请先输入手机号');
        return;
      }

      if (!/^1[3-9]\d{9}$/.test(this.userInfo.mobile)) {
        this.$message.warning('请输入正确的手机号');
        return;
      }

      // 调用发送验证码API
      sendSms({
        phone: this.userInfo.mobile,
        event: 'profile', // 或者根据接口要求修改为 'changemobile' 等事件
      }).then(response => {
        if (response.data.code == 1) {
          this.$message.success('验证码发送成功');
          this.startCountdown();
        } else {
          this.$message.error(response.data.msg || '验证码发送失败');
        }
      }).catch(error => {
        console.error('验证码发送失败:', error);
        this.$message.error('验证码发送失败');
      });
    },

    // 倒计时
    startCountdown() {
      this.codeTimer = 60;
      this.timer = setInterval(() => {
        this.codeTimer--;
        if (this.codeTimer <= 0) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },

    // 提交表单
    submitForm() {
      this.$refs.infoForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          // 注意：这里需要确认 updateUser 接口是否支持仅更新手机号
          // 如果需要传递其他字段（如头像、昵称），可能需要先获取当前用户信息
          const userInfoStr = localStorage.getItem('userInfo');
          let currentUserInfo = {};
          if (userInfoStr) {
            currentUserInfo = JSON.parse(userInfoStr);
          }

          updateMobile({
            mobile: this.userInfo.mobile,
            captcha: this.userInfo.code
          }).then(res => {
            if (res.data.code == 1) {
              this.$message.success('修改成功');
              // 更新本地存储的用户信息
              currentUserInfo.mobile = this.userInfo.mobile;
              localStorage.setItem('userInfo', JSON.stringify(currentUserInfo));
              this.loading = false;
            } else {
              this.$message.error(res.data.msg);
              this.loading = false;
            }
          }).catch(() => {
             this.loading = false;
          });
        }
      });
    },

    // 重置表单
    resetForm() {
      this.$refs.infoForm.resetFields();
    }
  }
};
</script>

<style lang="scss" scoped>
.info-container {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100vh;

  .info-box {
    max-width: 600px;
    margin: 0 auto;
    background: white;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

    h2 {
      text-align: center;
      margin-bottom: 30px;
      color: #333;
    }
  }
}
</style>
